/**
 * @file
 * @author chenyaqiu
 */
import Card from './Card';
export default Card;
